import _get from "lodash/get";
import { AnyAction } from "redux";
import * as ESIM_AT from "./actionTypes";
import { EsimState } from "../../../../models/state";
import * as AUTH_AT from "../../authentication/state/actionTypes";

export function fulfilled(actionType: keyof typeof AUTH_AT | keyof typeof ESIM_AT) {
    return `${actionType}_FULFILLED`;
}

export const initialState = (): EsimState => ({
    products: [],
    isPhoneNumberVerified: false,
});

const reducer = (state = initialState(), action: AnyAction): EsimState => {
    switch (action.type) {
        case fulfilled(ESIM_AT.ESIM_VERIFY_CODE):
            return {
                ...state,
                products: _get(action, "payload.result.products", []),
                isPhoneNumberVerified: _get(action, "payload.result.verified", false),
            };
        default:
            return state;
    }
};

export default reducer;
